import React from 'react'
import clsx from 'classnames'
import type { CityService } from 'src/store/data.store'
import type { SelectedService } from 'src/store/appointment.store'
import { formatPriceForSalon } from 'utils/formatPrice'
import { getServiceName } from 'utils/serviceOptions'
import styles from './ServicesSummaryItem.module.scss'

type ServicesSummaryItemProps = {
  service: SelectedService<CityService>,
  salonId?: number | null,
  className?: string,
}

/** One booked service in the booking summary: name, amount, duration and price */
export const ServicesSummaryItem: React.FC<ServicesSummaryItemProps> = (props) => {
  const { service, salonId, className } = props
  const name = getServiceName(service) ?? 'Услуга недоступна'
  const duration = (service.amount * service.duration) || 0
  return <div className={clsx([styles.container, className])}>
    <div className={styles.nameContainer}>
      <span className={styles.name}>{name}</span>
      {!!service.isAmountChangeable && <span className={styles.amount}>({service.amount})</span>}
    </div>
    <div className={styles.attributes}>
      <div className={styles.durationContainer}>
        <span className={styles.duration}>{duration}</span>
        <span className={styles.durationUnits}>мин</span>
      </div>
      <div className={styles.priceContainer}>
        <div className={styles.priceBg}>
          <span className={styles.price}>{formatPriceForSalon(service, salonId, service.amount)}</span>
          <span className={styles.currency}>₽</span>
        </div>
      </div>
    </div>
  </div>
}
